<dx-popup
    title="Edit Photo"
    [width]="400"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="photo" validationGroup="photoDialogValidationGroup">
        <dxi-form-item dataField="name" [label]="{ text: 'File Name' }" [isRequired]="true"></dxi-form-item>
        <dxi-form-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-form-item>
    </dx-form>
</dx-popup>
